import React from 'react';
import { Shield, Cpu, Wifi, Activity, AlertTriangle, CheckCircle, Search, RefreshCw, Plus, Eye, Lock, Unlock } from 'lucide-react';
import { Button } from '../ui/button';

const IoTEndpointsTab = ({ endpoints, categories, fetchEndpoints, registerEndpoint }) => (
  <div className="space-y-4">
          {endpoints.length === 0 ? (
            <div className="bg-white rounded-xl border shadow-sm p-8 text-center">
              <Cpu className="h-12 w-12 text-gray-300 mx-auto mb-4" />
              <h4 className="font-medium text-gray-700">No endpoints registered</h4>
              <p className="text-sm text-gray-500 mt-1">Register your first IoT endpoint</p>
              <Button onClick={() => setShowRegisterModal(true)} className="mt-4 bg-cyan-600 hover:bg-cyan-700">
                <Plus className="h-4 w-4 mr-2" />
                Register Endpoint
              </Button>
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
              {endpoints.map((endpoint) => {
                const CategoryIcon = getCategoryIcon(endpoint.category);
                return (
                  <div key={endpoint.id} className="bg-white rounded-xl border shadow-sm p-4 hover:shadow-md transition-shadow">
                    <div className="flex items-center justify-between mb-3">
                      <div className="flex items-center gap-3">
                        <div className="p-2 bg-cyan-100 rounded-lg">
                          <CategoryIcon className="h-5 w-5 text-cyan-600" />
                        </div>
                        <div>
                          <h4 className="font-medium text-gray-900">{endpoint.device_name}</h4>
                          <p className="text-xs text-gray-500">{endpoint.manufacturer} {endpoint.model}</p>
                        </div>
                      </div>
                      <span className={`px-2 py-0.5 rounded-full text-xs font-medium ${
                        endpoint.health_status === 'healthy' ? 'bg-green-100 text-green-700' :
                        endpoint.health_status === 'degraded' ? 'bg-yellow-100 text-yellow-700' :
                        'bg-red-100 text-red-700'
                      }`}>
                        {endpoint.health_status}
                      </span>
                    </div>
                    
                    <div className="grid grid-cols-2 gap-2 mb-3 text-sm">
                      <div>
                        <p className="text-xs text-gray-500">Category</p>
                        <p className="text-gray-700 capitalize">{endpoint.category?.replace('_', ' ')}</p>
                      </div>
                      <div>
                        <p className="text-xs text-gray-500">Firmware</p>
                        <p className="text-gray-700">{endpoint.firmware_version}</p>
                      </div>
                      <div>
                        <p className="text-xs text-gray-500">Security Score</p>
                        <p className={`font-medium ${
                          endpoint.security_score >= 80 ? 'text-green-600' :
                          endpoint.security_score >= 50 ? 'text-yellow-600' : 'text-red-600'
                        }`}>{endpoint.security_score || 100}</p>
                      </div>
                      <div>
                        <p className="text-xs text-gray-500">Anomalies</p>
                        <p className="text-gray-700">{endpoint.anomaly_count || 0}</p>
                      </div>
                    </div>
                    
                    <div className="flex flex-wrap gap-1 mb-3">
                      {endpoint.protocols?.map((protocol) => (
                        <span key={protocol} className="px-2 py-0.5 bg-gray-100 text-gray-600 text-xs rounded">
                          {protocol}
                        </span>
                      ))}
                    </div>
                    
                    <div className="flex gap-2 pt-3 border-t">
                      <Button
                        variant="outline"
                        size="sm"
                        onClick={() => scanFirmware(endpoint)}
                        className="flex-1"
                      >
                        <Shield className="h-3 w-3 mr-1" />
                        Scan
                      </Button>
                      <Button
                        variant="outline"
                        size="sm"
                        onClick={() => analyzeTraffic(endpoint)}
                        className="flex-1"
                      >
                        <Wifi className="h-3 w-3 mr-1" />
                        Traffic
                      </Button>
                      <Button
                        variant="outline"
                        size="sm"
                        onClick={() => detectAnomalies(endpoint)}
                        className="flex-1"
                      >
                        <Activity className="h-3 w-3 mr-1" />
                        Detect
                      </Button>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
);

export default IoTEndpointsTab;
